import { DocumentoPessoaType, PaisList } from '_metronic/helpers'

/** Documento da lista de documentos da pessoa (SBIS ECF.02.01). CPF e CNS ficam no formulário principal. */
export type DocumentoPessoa = {
  id: number
  tipo: DocumentoPessoaType
  descricao?: string
  numero: string
  complemento?: string | null
  serie?: string | null
  orgao?: string | null
  uf?: string | null
  expedicao?: string | null
  validade?: string | null
  paisEmissor?: PaisList | null
}

export type DocumentoPessoaDtoUpdate = {
  numero: string
  complemento?: string
  serie?: string
  orgao?: string
  uf?: string
  expedicao?: string
  validade?: string
  paisEmissor?: number
}

export type DocumentoPessoaDtoCreate = DocumentoPessoaDtoUpdate & {
  tipo: DocumentoPessoaType
}

/** Rotas do dono da lista (`/funcionarios/documento` ou `/pacientes/documento`). */
export type DocumentosPessoaRequests = {
  listar: (ownerId: number) => Promise<DocumentoPessoa[]>
  criar: (ownerId: number, dto: DocumentoPessoaDtoCreate) => Promise<DocumentoPessoa>
  atualizar: (
    ownerId: number,
    idDocumento: number,
    dto: DocumentoPessoaDtoUpdate
  ) => Promise<DocumentoPessoa>
  excluir: (ownerId: number, idDocumento: number) => Promise<void>
}

/** Tipos que vão para a lista; CPF e CNS são do formulário principal. */
export const TIPOS_DOCUMENTO_LISTA: DocumentoPessoaType[] = [
  DocumentoPessoaType.Rg,
  DocumentoPessoaType.Passaporte,
  DocumentoPessoaType.Ctps,
  DocumentoPessoaType.BilheteIdentidadeAngola,
]

/** Documentos que identificam a pessoa sozinhos quando ela não tem CPF nem CNS (estrangeiro). */
export const TIPOS_DOCUMENTO_ESTRANGEIRO: DocumentoPessoaType[] = [
  DocumentoPessoaType.Passaporte,
  DocumentoPessoaType.BilheteIdentidadeAngola,
]
